
import { defineComponent } from 'vue'
import Square from '@/components/Square.vue'

export default defineComponent({
  name: 'Decade',

  components: {
    Square
  },

  props: {
    decadeNum: {
      type: Number,
      default: 0
    },

    weeksPassed: {
      type: Number,
      default: 0
    }
  }
})
